export default __webpack_public_path__ + "static/media/mail.fd1d9ca4.svg";